import React from 'react';
import classnames from 'classnames';
import { func, node, element } from 'prop-types';
import Vbox from './vbox';
import Toolbar, { ToolbarRow, ToolbarSection } from '../toolbar';
import ButtonIcon from '../icon/button';
import withLoading from '../wrappers/withLoading';

const Secondary = ({
  title,
  onClose,
  loadingComponent,
  children,
  className,
  tabsRow,
  tools,
}) => (
  <Vbox
    className={classnames(
      'secondary',
      className,
    )}
  >
    <Toolbar className="secondary-header">
      {title && (
        <ToolbarRow>
          <ToolbarSection align={ToolbarSection.ALIGN_START}>
            <div className="mdc-toolbar__title">
              {title}
            </div>
          </ToolbarSection>
          {tools &&
            <ToolbarSection align={ToolbarSection.ALIGN_END} shrink>
              {tools}
            </ToolbarSection>
          }
          <ToolbarSection align={ToolbarSection.ALIGN_END} shrink>
            <ButtonIcon
              className="mdc-toolbar__icon"
              onClick={onClose}
            >close
            </ButtonIcon>
          </ToolbarSection>
        </ToolbarRow>
      )}
      {tabsRow &&
        <ToolbarRow className="mdc-toolbar__row-48">
          <ToolbarSection
            shrink
            align={ToolbarSection.ALIGN_START}
            className="mdc-toolbar__section-tabs"
          >{tabsRow}
          </ToolbarSection>
        </ToolbarRow>
      }
    </Toolbar>
    <Vbox className="secondary-content">
      {loadingComponent}
      {children}
    </Vbox>
  </Vbox>
);

Secondary.propTypes = {
  title: node,
  loadingComponent: element.isRequired,
  onClose: func.isRequired,
  children: node.isRequired,
  tabsRow: node,
  tools: node,
};

Secondary.defaultProps = {
  title: null,
  tabsRow: null,
  tools: null,
};

export default withLoading()(Secondary);
